exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 16.66%;\n  background-color: #f5f5f5;\n  overflow-y: auto;\n  max-height: calc(100vh - 51px);\n}\n\n:host .sidebar{\n  width:100%;\n  padding:10px;\n}\n\n:host .sidebar h2{\n  font-size:18px;\n  padding-bottom: 5px;\n}\n:host ul{\n  padding-bottom: 10px;\n  border-bottom: 1px solid #e5e5e5;\n}\n\n:host .active, :host .nav li:hover{\n  background: #428bca;\n}\n:host .nav>li>a:focus, :host .nav>li>a:hover{\n  background: transparent;\n}\n\n:host .active a, :host .nav li:hover a{\n  color: #FFF;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/wiserisk-core/src/main/ng4app/src/app/components/sidenav/sidenav.component.css
// module id = ../../../../../src/app/components/sidenav/sidenav.component.css
// module chunks = main